import ArrowDown from "./ArrowDown";
import ArrowUp from "./ArrowUp";

export default function SortIcon({
  size = 16,
  color = "currentColor",
  ...props
}) {
  return (
    <span
      style={{
        display: "inline-flex",
        flexDirection: "column",
        marginLeft: 4,
        verticalAlign: "middle",
      }}
    >
      <ArrowUp size={size} {...props}/>
      <ArrowDown size={size} {...props}/>
    </span>
  );
}
